import React, { useMemo } from "react";
import { View, Text, StyleSheet, ScrollView } from "react-native";
import { Trans, useTranslation } from "react-i18next";
import SuccessIcon from "../../../../../../../assets/images/success-icon-component.svg";
import Colors from "../../../../constants/colors";
import { ComponentStyles } from "../../../../constants/componentStyles";

type Props = {
  testID?: string;
};

export default function FraudPreventionStep({ testID }: Props) {
  const { t } = useTranslation();

  const fraudBriefComponents = useMemo(
    () => ({
      warn: <Text style={[styles.paragraph, styles.warnStrong]} />,
    }),
    []
  );

  return (
    <ScrollView
      testID={testID}
      style={styles.container}
      contentContainerStyle={styles.content}
      showsVerticalScrollIndicator={false}
    >
      {/* Check icon */}
      <View style={styles.iconCircle}>
        <SuccessIcon width={64} height={64}/>
        <Text style={styles.title}>{t("FRAUD_PREVENTION_TITLE")}</Text>
      </View>

      {/* Heading */}
      <Text style={styles.subtitle}>
        {t("FRAUD_SUBTITLE")}
      </Text>

      {/* Body */}
      <Text style={[styles.paragraph, { marginBottom: 16 }]}>
        <Trans i18nKey="FRAUD_BRIEF_INFO" components={fraudBriefComponents} />
      </Text>

      <View style={{ flexDirection: 'row'}}>
        <Text style={[styles.paragraph, {marginRight: 8}]}>1.</Text>
        <Text style={styles.paragraph}>{t("FRAUD_FIRST_POINT")}</Text>
      </View>
      <View style={{ flexDirection: 'row'}}>
        <Text style={[styles.paragraph, {marginRight: 8}]}>2.</Text>
        <Text style={styles.paragraph}>{t("FRAUD_SECOND_POINT")}</Text>
      </View>
      <View style={{ flexDirection: 'row'}}>
        <Text style={[styles.paragraph, {marginRight: 8}]}>3.</Text>
        <Text style={styles.paragraph}>{t("FRAUD_THIRD_POINT")}</Text>
      </View>
      <View style={{ flexDirection: 'row', marginBottom: 16}}>
        <Text style={[styles.paragraph, {marginRight: 8}]}>4.</Text>
        <Text style={styles.paragraph}>{t("FRAUD_FOURTH_POINT")}</Text>
      </View>

      <Text style={[styles.paragraph, { marginBottom: 18}]}>
        {t("FRAUD_PRE_CONTACT")}
      </Text>

      <Text style={[styles.paragraph, { fontWeight: '500', marginBottom: 16}]}>
        {t("FRAUD_CONFIRMATION")}
      </Text>

      <Text style={styles.paragraph}>
        {t("FRAUD_PRE_CONCLUSION")}
      </Text>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.white,
  },
  content: {
    paddingHorizontal: 24,
    paddingTop: 24,
    paddingBottom: 0, // parent screen adds 32px after content for fraud step
  },
  iconCircle: {
    alignSelf: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: ComponentStyles.titleFont,
    fontWeight: '500', 
    color: Colors.titleTextColor,
    lineHeight: 34,
    marginBottom: 32,
    paddingTop: 24
  },
  subtitle: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: 14,
    fontWeight: '500', 
    color: Colors.subTitleColor,
    lineHeight: 22,
    marginBottom: 24,
  },
  paragraph: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: 14,
    fontWeight: '400', 
    color: Colors.subTitleColor,
    lineHeight: 22,
  },
  warnStrong: {
    fontWeight: "600",
    color: "#111827",
  },
});